import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'redis',
  name: 'Redis',
  category: 'database',
  description: 'Store, retrieve, and manage data in Redis. Supports key-value operations, lists, pub/sub, and caching with TTL.',
  icon: 'siRedis',
  iconType: 'simple-icon',
  color: 'red',
  version: '1.0.0',
  group: ['transform'],
  defaults: {
    name: 'Redis',
    color: '#dc382d',
  },
  credentials: [
    {
      name: 'redis',
      required: true,
      displayName: 'Redis',
    },
  ],
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
  tags: ['redis', 'cache', 'database', 'key-value', 'nosql', 'pub-sub'],
  comingSoon: false,

  // Tool-capable configuration for AI Agent
  toolCapable: {
    enabled: true,
    name: 'redis_database',
    description: 'Store and retrieve data from Redis. Supports key-value operations, bulk operations, list operations, pub/sub, and database management.',
    allowManualDescription: true,
    parameters: {
      operation: {
        toolParamName: 'operation',
        description: 'The Redis operation: get, set, delete, increment, keys, info, push, pop, listLength, publish, bulkSet, multiGet, keyExists, dbSize, flushDb',
        required: true,
        type: 'string',
      },
      key: {
        toolParamName: 'key',
        description: 'The key name for key-value operations',
        required: false,
        type: 'string',
      },
      value: {
        toolParamName: 'value',
        description: 'The value to set',
        required: false,
        type: 'string',
      },
      sourceArray: {
        toolParamName: 'sourceArray',
        description: 'Source array data for bulkSet operation',
        required: false,
        type: 'array',
      },
      list: {
        toolParamName: 'list',
        description: 'List name for list operations',
        required: false,
        type: 'string',
      },
    },
    outputMapping: {
      value: 'The retrieved or resulting value',
      success: 'Whether the operation completed successfully',
      exists: 'Whether the key exists (for keyExists operation)',
      dbSize: 'Number of keys in the database (for dbSize operation)',
    },
  },
};

export default definition;
